import { Component, Input, OnChanges, OnDestroy, OnInit, inject } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective } from '@angular/forms';
import { DictionaryItem } from 'src/app/models/dictionary-item';

@Component({
  selector: 'app-readonly-inline-list-filter',
  templateUrl: './readonly-inline-list-filter.component.html',
  styleUrl: './readonly-inline-list-filter.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  standalone: false
})
export class ReadonlyInlineListFilterComponent implements OnInit, OnChanges, OnDestroy {
  formGroupDirective = inject(FormGroupDirective);

  @Input() name: string;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() datasource: DictionaryItem[];
  @Input() changeCallback: (value: string) => void;
  @Input() description?: string;

  public badgeCount: number;
  public tooltip: string;

  public readonly inputControl = new FormControl(null);


  constructor() {
  }

  ngOnInit(): void {
    this.addControl();
  }

  ngOnDestroy(): void {
    this.removeControl();
  }
  ngOnChanges(): void {
    this.inputControl.disable();
    this.inputControl.setValue(this.datasource?.map(source => source.Name).join('; '), { emitEvent: false });
    this.tooltip = this.datasource?.map(source => source.Name).join('\n');
    this.badgeCount = this.datasource?.length;
  }

  private addControl(): void {
    this.formGroupDirective.form.addControl(this.name, new FormControl(null), { emitEvent: false });
  }

  private removeControl(): void {
    this.formGroupDirective.form.removeControl(this.name, { emitEvent: false });
  }
}
